import React from "react";
import PropTypes from "prop-types";
import { Avatar, Chip } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

const DIVISION_UI = {
  11: { label: "Valderma", avatarAlt: "VD", avatarSrc: "/media/products/valderma.png", avatarFallback: "VD" },
  1: { label: "Roypet", avatarAlt: "RP", avatarSrc: "/media/products/roypet.png", avatarFallback: "RP" },
  2: { label: "Roydermal", avatarAlt: "RD", avatarSrc: "/media/products/roydermal.png", avatarFallback: "RD" },
};

export const DivisionChip = React.memo(function DivisionChip({ division, className }) {
  const ui = DIVISION_UI[Number(division)];
  if (!ui) return null;

  return (
    <Chip
      className={className}
      variant="outlined"
      avatar={
        <Avatar alt={ui.avatarAlt} src={toAbsoluteUrl(ui.avatarSrc)} style={{ backgroundColor: "transparent" }}>
          {ui.avatarFallback}
        </Avatar>
      }
      label={ui.label}
    />
  );
});

DivisionChip.propTypes = {
  division: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
};

